/*eslint-disable*/
import React, { useState } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardImg,
    CardTitle,
    Row,
    Col,
    Modal
} from "reactstrap";

// core components
import { LoadingScreen } from "../../MiscFunctions";
import CustomCarousel from "../../CustomCarousel"

function Event(
    {
        caption,
        categoryName,
        description,
        pictures,
        isDisplayed,
        size = "4",
        admin,
        event,
        setEvent,
        del,
        flag,
        setFlag,
        setDeleted
    }) {

    const carouselItems = pictures.map((picture) => {
        return (
            {
                src: picture,
                altText: description,
                caption: caption,
            }
        )
    })

    // Modal
    const [smallAlert, setSmallAlert] = useState(false);

    return (
        <>
            <Col md={size} style={{ zIndex: 0 }}>
                {
                    event ?
                        <Card className="card-profile card-plain" style={{ marginTop: admin && "0" }}>
                            <CardImg top tag="div">
                                <Card
                                    className="card-raised page-carousel"
                                    style={{ backgroundColor: "inherit", boxShadow: "none" }}
                                >
                                    <CustomCarousel
                                        style={{ maxHeight: "50vh", width: "auto", minHeight: "40vh" }}
                                        carouselItems={carouselItems}
                                    />
                                </Card>
                            </CardImg>
                            <CardBody>
                                {
                                    admin &&
                                    <Row>
                                        <Col md={6} xs={6} lg={6} style={{ textAlign: "right" }}>
                                            <a
                                                data-number="1"
                                                href="#edit"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    document.getElementById("edit").scrollIntoView({
                                                        behavior: "smooth",
                                                        block: "start",
                                                        inline: "nearest",
                                                    });
                                                }}
                                            >
                                                <Button
                                                    className="btn"
                                                    color="info"
                                                    type="button"
                                                    onClick={() => {
                                                        setDeleted([])
                                                        setEvent(event)
                                                        setFlag(!flag)
                                                    }}
                                                >
                                                    Edit
                                            </Button>
                                            </a>
                                        </Col>
                                        <Col md={6} xs={6} lg={6} style={{ textAlign: "left" }}>
                                            <Button
                                                className="btn"
                                                color="danger"
                                                type="button"
                                                onClick={() => {
                                                    setSmallAlert(true)
                                                    setEvent(null)
                                                    setFlag(!flag)
                                                }}
                                            >
                                                Delete
                                        </Button>
                                        </Col>
                                    </Row>
                                }
                                <h6 className="card-category">{categoryName}</h6>
                                <CardTitle tag="h4">
                                    {caption}
                                </CardTitle>
                                <p className="card-description">
                                    {description}
                                </p>
                                {
                                    admin &&
                                    <p className="card-description">
                                        {`Displayed: ${isDisplayed}`}
                                    </p>
                                }
                            </CardBody>
                        </Card>
                        :
                        <LoadingScreen />
                }
            </Col>

            {/* Modals */}
            {/* Delete Confirmation */}
            <Modal
                size="sm"
                isOpen={smallAlert}
                toggle={() => setSmallAlert(false)}
            >
                <div className="modal-header no-border-header">
                    <button
                        className="close"
                        type="button"
                        onClick={() => setSmallAlert(false)}
                    >
                        ×
                  </button>
                </div>
                <div className="modal-body text-center">
                    <h5 style={{ fontWeight: "400" }}>Are you sure you want to <span className="text-danger">delete </span>
                        <br />
                        "<i style={{ fontWeight: "500" }}>{event.caption}</i>"?
                    </h5>
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button
                            className="btn-link"
                            color="default"
                            type="button"
                            onClick={() => setSmallAlert(false)}
                        >
                            Never mind
                        </Button>
                    </div>
                    <div className="divider" />
                    <div className="right-side">
                        <Button className="btn-link" color="danger" type="button" onClick={
                            async () => {
                                // Closes modal 
                                setSmallAlert(false)
                                // Delete event
                                del(event)
                            }}>
                            Yes
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default Event;
